(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SimPhoneDialogController', SimPhoneDialogController);

    SimPhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SimPhone', 'CloudPBX'];

    function SimPhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SimPhone, CloudPBX) {
        var vm = this;

        vm.simPhone = entity;
        vm.clear = clear;
        vm.save = save;
        vm.cloudpbxes = CloudPBX.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.simPhone.id !== null) {
                SimPhone.update(vm.simPhone, onSaveSuccess, onSaveError);
            } else {
                SimPhone.save(vm.simPhone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:simPhoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
